<template>
   <v-container>
       <v-row align="center" justify="center">
           <v-col cols="12" lg="10" md="10" sm="12" xs="12" align="center" class="mt-10 mx-auto">
               <!-- <v-img :src="logo" max-width="200" class="mb-5"></v-img> -->
               <h2 class="login-title">Verificar correo electrónico</h2>
               <p>Para continuar, por favor haga clic al enlace de verificación que fue enviado a su correo electrónico.</p>
               <v-btn outlined large :loading="loading" @click="verify" :color="color">Solicitar un nuevo enlace</v-btn>
               <v-img :src="img" class="mt-7" width="40%"></v-img>
           </v-col>
       </v-row>
   </v-container>
</template>
<script>

import iziToast from 'izitoast'

export default {
    data: () => ({
        img:"/images/verify.png",
        logo:"/images/neumann-logo-black.png",
        loading:false,

        color:'#000'
    }),

    methods:{
        'verify':function(){
            this.loading = true
            axios.post("/email/resend").then(response => {
                this.loading = false
                iziToast.success({
                    class:"app-toast",
                    title:"Correcto",
                    message:"Se ha enviado un nuevo enlace de verificación",
                    position:"topRight"
                })
            }).catch(error => {
                this.loading = false
                iziToast.error({
                    class:"app-toast",
                    title:"Error",
                    message:"Ha ocurrido un error, intente más tarde",
                    position:"topRight"
                })
            });
        }
    }
}
</script>
